var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3374 1.54509C15.7237 0.815621 14.5908 0.518066 12.4271 0.518066H4.57278C2.35955 0.518066 1.20738 0.834815 0.596042 1.61144C0 2.36865 0 3.48435 0 5.0285V7.97163C0 10.9631 0.7072 12.482 4.57278 12.482H12.4271C14.3035 12.482 15.3432 12.2194 16.0159 11.5757C16.7057 10.9155 17 9.83769 17 7.97163V5.0285C17 3.40006 16.9539 2.27779 16.3374 1.54509ZM10.9141 6.90639L7.34746 8.77042C7.26772 8.81209 7.18053 8.83277 7.09344 8.83277C6.99484 8.83277 6.89646 8.80622 6.80932 8.75347C6.64525 8.65405 6.54505 8.47621 6.54505 8.28438V4.56829C6.54505 4.37679 6.64497 4.19911 6.80872 4.09964C6.97252 4.00016 7.17625 3.99336 7.34619 4.08165L10.9128 5.93366C11.0943 6.02788 11.2082 6.21521 11.2085 6.41959C11.2087 6.62414 11.0952 6.81174 10.9141 6.90639Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4beb941b6b9fd22897b57c9f26269754.svg";
export { ForwardRef as ReactComponent };